import { render } from "./App.vue?vue&type=template&id=50d03282"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=50d03282&lang=css"
import "./App.vue?vue&type=style&index=1&id=50d03282&lang=scss"

import exportComponent from "/workspace/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__